import { put, call } from 'redux-saga/effects';
import * as types from './company-contexts.types';
import * as actions from './company-contexts.actions';

import * as api from '../../api/request-config/company-contexts.api';
import { apiRequest } from '../../api/api.saga-services';
import { ICompanyToolsCategory } from '../company-tools-category/company-tools-category.types';

export function* storeCompanyContext(companyContext: types.ICompanyContext | types.ICompanyContext[]) {
  yield put(actions.storeCompanyContext(companyContext));
  return companyContext;
}

export function* clearCompanyContext(companyContextId: types.ICompanyContext['id']) {
  yield put(actions.clearCompanyContext(companyContextId));
}

export function* clearAllCompanyContexts() {
  yield put(actions.clearCompanyContext(null));
}

export function* storeCompanyContextsFromRawList(rawList: Record<string, unknown>[]) {
  yield call(clearAllCompanyContexts);
  const rows = rawList.map((r) => normalizeCompanyContext(r));
  yield call(storeCompanyContext, rows);
  return rows.map((r) => r.id);
}

export function* searchCompanyContexts() {
  const rawList = (yield call(apiRequest, api.getCompanyContextsApi())) as Record<string, unknown>[] | null;
  if (rawList === null) {
    return [];
  }

  return (yield call(storeCompanyContextsFromRawList, rawList)) as types.ICompanyContext['id'][];
}

export function* createCompanyContext(companyToolsCategoryId: ICompanyToolsCategory['id']) {
  const raw = (yield call(apiRequest, api.createCompanyContextApi(companyToolsCategoryId))) as Record<
    string,
    unknown
  > | null;
  if (!raw) {
    return;
  }
  const companyContext = normalizeCompanyContext(raw);
  yield call(storeCompanyContext, companyContext);
  return companyContext;
}

export function* updateCompanyContext(
  companyContextId: types.ICompanyContext['id'],
  data: types.ICompanyContextUpdate,
) {
  const raw = (yield call(apiRequest, api.updateCompanyContextApi(companyContextId, data))) as Record<
    string,
    unknown
  > | null;
  if (!raw) {
    return;
  }
  const companyContext = normalizeCompanyContext(raw);
  yield call(storeCompanyContext, companyContext);
  return companyContext;
}

export function* deleteCompanyContext(companyContextId: types.ICompanyContext['id']) {
  const result = yield call(apiRequest, api.deleteCompanyContextApi(companyContextId));
  if (result !== null) {
    yield call(clearCompanyContext, companyContextId);
  }
}

function normalizeCompanyContext(raw: Record<string, unknown>): types.ICompanyContext {
  return {
    id: String(raw.id),
    title: typeof raw.title === 'string' ? raw.title : '',
    summary: typeof raw.summary === 'string' ? raw.summary : '',
    content: typeof raw.content === 'string' ? raw.content : '',
    sort: typeof raw.sort === 'number' ? raw.sort : Number(raw.sort) || 0,
    companyToolsCategoryId: String(raw.companyToolsCategoryId ?? raw.company_tools_category_id ?? ''),
    createdAt: String(raw.createdAt ?? raw.created_at ?? ''),
    updatedAt: String(raw.updatedAt ?? raw.updated_at ?? ''),
  };
}
